import { ClipboardList, Users, FileSearch, Building2, CheckCircle2 } from "lucide-react";

const phases = [
  {
    icon: ClipboardList,
    status: "In progress",
    label: "Environmental surveys",
    body: "Terrestrial ecology, habitats, bats and badgers, flood-risk assessment and hydrology surveys are underway across the site.",
  },
  {
    icon: Users,
    status: "In progress",
    label: "Public & statutory consultation",
    body: "Pre-planning conversations with Galway County Council, NPWS, EPA and IFI are ongoing. This website and information days are part of the public phase.",
  },
  {
    icon: FileSearch,
    status: "Next",
    label: "Refine the layout",
    body: "Feedback from surveys and the community is fed back into the design. The layout you see today will continue to evolve before submission.",
  },
  {
    icon: Building2,
    status: "Q3 2026",
    label: "Planning application",
    body: "A full planning application will be submitted to Galway County Council in the third quarter of 2026. The substation will be a separate application.",
  },
  {
    icon: CheckCircle2,
    status: "After consent",
    label: "Construction & operation",
    body: "Subject to consent: 18–24 months of construction, followed by decades of clean generation. End of life — piles removed, fields reinstated.",
  },
];

export default function PlanningProcess() {
  return (
    <section id="planning" className="bg-[#F9F8F6]" data-testid="planning-process-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-12">
          <div className="lg:col-span-5 reveal">
            <p className="overline mb-4">Planning process</p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight">
              Where we are — and what happens next.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <p className="text-[15px] leading-relaxed text-[#2A2B2A]/85">
              We are at the pre‑planning stage. That means the project is still
              being shaped, and the community’s questions matter. The further
              ahead of the application we hear from you, the more we can do with
              that feedback.
            </p>
          </div>
        </div>

        <ol className="relative border-l border-[#E0DCD3] ml-4 lg:ml-6 space-y-8">
          {phases.map((p, i) => {
            const Ic = p.icon;
            return (
              <li key={i} className="pl-8 lg:pl-10 relative reveal" data-testid={`phase-${i}`}>
                <span className="absolute -left-[14px] top-1 inline-flex h-7 w-7 items-center justify-center rounded-sm bg-[#F9F8F6] border border-[#E0DCD3]">
                  <Ic className="h-3.5 w-3.5 text-[#3A4B3A]" strokeWidth={1.9} />
                </span>
                <div className="flex flex-wrap items-baseline gap-3">
                  <span className="text-[10.5px] tracking-[0.2em] uppercase font-bold text-[#CBA365]">
                    {p.status}
                  </span>
                  <h3 className="font-serif-display text-xl tracking-tight">{p.label}</h3>
                </div>
                <p className="mt-2 text-[14.5px] leading-relaxed text-[#63635E] max-w-2xl">{p.body}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
